import { NavGraph, NavGraphItem, Document } from 'src/types/navGraph';
import { NAV_GRAPH_ROOT_NODE_ID } from 'src/components/providers/NavGraphProvider';

const findInPath = (
    paths: number[],
    node: NavGraph,
    accessor: keyof NavGraphItem
): NavGraphItem | undefined => {
    const path = paths.shift();
    const nextNavGraphItemKey = Object.keys(node).find((key) => {
        const nextNode = node[key];
        return nextNode[accessor] === path;
    });

    if (nextNavGraphItemKey === undefined) {
        return undefined;
    }

    const nextNode = node[nextNavGraphItemKey];
    if (!paths.length) {
        return nextNode;
    } else if (nextNode.children) {
        return findInPath(paths, nextNode.children, accessor);
    }
    return undefined;
};

export const findInNavGraph = (
    artifactId: number,
    path: string,
    node: NavGraph,
    accessor: keyof NavGraphItem
): Document | undefined => {
    if (!node) {
        return undefined;
    }
    // If a string needs to be selected, such as name, the path will need to be sent in as a param so that it can be mapped
    // Otherwise the findInPath === will throw an error on '123' === 123
    const paths = path
        .split('/')
        .filter(Boolean)
        .map((path) => parseInt(path))
        .filter((path) => path !== NAV_GRAPH_ROOT_NODE_ID);
    const lastNodeInPath = findInPath(paths, node, accessor);

    if (lastNodeInPath && lastNodeInPath.documents) {
        return lastNodeInPath.documents[artifactId];
    }
    return undefined;
};
